let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fESa7")).then(() => parcelRequire('1kKoV'));